export enum NotificationStatus {
  SENT=1,
  READ=2,
  UNREAD=3,
  ARCHIVED=4,
}